import { Disclosure } from "@headlessui/react";
import { useRecoilState } from "recoil";
import {
  resetSubmoduleDataState,
  showScriptsSubmoduleState,
  submoduleDatas,
} from "../atoms/atom";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

export const ModuleScriptTable = ({
  moduleData,
  moduleName,
  filteredText,
  setFilterText,
  index,
}) => {
  const [tableData, setTableData] = useState();
  const [isShowSubmodule, setIsShowSubmodule] = useRecoilState(
    showScriptsSubmoduleState
  );
  const [submoduleData, setSubmoduleData] = useRecoilState(submoduleDatas);
  const [filteredData, setFilteredData] = useState();
  const [resetScriptDatas, setResetScriptDatas] = useRecoilState(
    resetSubmoduleDataState
  );

  const onClickVendorName = (moduleName) => {
    const moduleDatas = moduleData?.filter((x) => x.moduleName === moduleName);
    setSubmoduleData(moduleDatas);
    setIsShowSubmodule(true);
  };
  //use for re-filterring submodule data upon edit
  const triggerCount = useRef(0);
  useEffect(() => {
    triggerCount.current += 1;
    const mData =
      submoduleData && submoduleData.filter((x) => x.groupName === moduleName);
    if (index === triggerCount.current) {
      if (resetScriptDatas) {
        if (mData && mData[0]?.moduleName === submoduleData[0]?.moduleName) {
          const moduleDatas = moduleData?.filter(
            (x) => x.moduleName === mData[0]?.moduleName
          );
          setSubmoduleData(moduleDatas);
          setResetScriptDatas(false);
          setIsShowSubmodule(true);
          triggerCount.current = 0;
        }
      }
    }
  }, [moduleData]);

  const matColumns = [
    {
      title: "Module Name",
      field: "moduleName",
      render: (rowData) => {
        return (
          <span
            className="blueAndBold underline cursor-pointer"
            onClick={() => {
              onClickVendorName(rowData.moduleName);
              setFilterText("");
            }}
          >
            {rowData.moduleName}
          </span>
        );
      },
    },
    {
      title: "# of scripts",
      field: "numberOfScripts",
      align: "center",
    },
    {
      title: "Description",
      field: "description",
      align: "left",
    },
    {
      title: "Created by",
      field: "createdBy",
      align: "left",
    },
    {
      title: "Modified by",
      align: "left",
      render: (rowdata) => {
        return (
          <div>{rowdata.modifiedBy ? rowdata.modifiedBy : "unspecified"}</div>
        );
      },
    },
  ];

  //Get specific module name for table data
  const uniqueModuleName = [
    ...new Set(moduleData?.map((item) => item.moduleName)),
  ];

  //sorting table data base on uniqueModuleName
  useEffect(() => {
    const sortedData = uniqueModuleName.map((module) => {
      const scripts = moduleData?.filter((x) => x.moduleName === module);
      const datas = {
        moduleName: module,
        numberOfScripts: scripts.length,
        createdBy: scripts[0]?.createdBy,
        modifiedBy: scripts[0]?.modifiedBy,
        description: "List of functions",
      };
      return datas;
    });
    if (sortedData) {
      setTableData(sortedData);
    }
    if (filteredItems) {
      setFilteredData(filteredItems);
    }
  }, [filteredText, moduleData]);

  //Filters
  const filteredItems = tableData?.filter((item) =>
    item.moduleName?.toLowerCase()?.includes(filteredText?.toLowerCase())
  );

  return (
    <>
      <div className="rounded bg-white space-y-3 px-4 pb-4 border-solid border-2 border-black-600">
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <>
              <Disclosure.Button className="disclosureBtn my-1 flex justify-start w-full  py-2  text-sm font-medium text-left">
                {open ? (
                  <MinusIcon className="text-blue-500 p-px rounded-sm w-4 h-4" />
                ) : (
                  <PlusIcon className="text-blue-500 p-px rounded-sm w-4 h-4" />
                )}
                <div>
                  <span className="text-quinary font-bold text-sm ml-2">
                    {moduleName}
                  </span>
                </div>
              </Disclosure.Button>
              <Disclosure.Panel>
                <MaterialExTable
                  columns={matColumns}
                  data={filteredText ? filteredData : tableData}
                  isLoading={false}
                  selection={false}
                  setOpenModal={false}
                  isDeactivate={false}
                  selectableRowDisabled={false}
                  paging={false}
                />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
};
